import type { Breadcrumb } from '@sentry/nextjs';
import { logBreadcrumb as clientBreadcrumb, log as clientLog } from './client';
import { logBreadcrumb as serverBreadcrumb, log as serverLog } from './server';

/**
 * Send to sentry and our logs if on server
 * @param breadcrumb Sentry Breadcrumb
 */
export const logBreadcrumb = (
  breadcrumb: Breadcrumb,
  cookies?: Partial<{ [key: string]: string }>
) => {
  if (typeof window === 'undefined') {
    serverBreadcrumb(breadcrumb, cookies);
  } else {
    clientBreadcrumb(breadcrumb);
  }
};

interface BaseProps {
  location?: string;
  cookies?: Partial<{ [key: string]: string }>;
}

interface ErrorProps extends BaseProps {
  error: unknown | string | Error;
  message?: never;
}
interface MessageProps extends BaseProps {
  error?: never;
  message: unknown | string | Error;
}

export type LogOptions = ErrorProps | MessageProps;

/**
 * Used to send errors and messages to our internal logs and sentry
 * @param error either a string or an Error
 * @param message either a string or an Error
 * @param location if not obvious from error, where it was triggered
 * @param cookies for server logs will need to be passed from cookies, client gets it itself
 */
export const log = ({ error, message, location, cookies }: LogOptions) => {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    if (typeof error !== 'undefined') {
      serverLog({
        error,
        location,
        cookies,
      });
    } else {
      serverLog({
        message,
        location,
        cookies,
      });
    }
  } else {
    if (typeof error !== 'undefined') {
      clientLog({ error, location });
    } else {
      clientLog({ message, location });
    }
  }
};
